/**
 * Shared text-metric constants consumed by both the geometry estimator
 * (markup-geometry/normalize.ts) and the renderers (render-model/).
 * A single definition prevents the box estimate and the paint path from drifting.
 */

/** Line-height multiplier: rendered line height = fontSize * TEXT_LINE_HEIGHT_RATIO. */
export const TEXT_LINE_HEIGHT_RATIO = 1.5;

/** Approximate character-width multiplier for bounding-box estimation. */
export const TEXT_CHAR_WIDTH_RATIO = 0.6;

/** Underline vertical offset below the baseline in PDF points (negative = below). */
export const UNDERLINE_OFFSET_PT = -2;

/** Strikethrough vertical position as a fraction of fontSize above the baseline. */
export const STRIKETHROUGH_RATIO = 0.35;

/** Decoration line thickness as a fraction of fontSize (floored at 1pt). */
export const DECORATION_THICKNESS_RATIO = 0.05;
